<template lang="html">
  <div>
    <v-form
      ref="incomeTypeForm"
      class="overflow"
      data-simplebar
    >
      <v-card>
        <v-card-title>Type of Income</v-card-title>
      </v-card>  
  
      <v-container>
        <v-row>
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="salary"
              v-money="money"
              :error-messages="errors.collect('salary')"
              data-vv-name="salary"
              label="Salary, fees, wages, and overtime pay"
              prefix="RM"
            />            
          </v-col>
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="commissionBonus"
              v-money="money"
              :error-messages="errors.collect('commissionBonus')"
              data-vv-name="commissionBonus"
              label="Commission and bonus"
              prefix="RM"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-text-field
              v-model="bik"
              v-money="money"
              :error-messages="errors.collect('bik')"
              data-vv-name="bik"
              label="BIK"
              prefix="RM"
            />
          </v-col>
          <v-col
            lg="6"
            class="py-0"
          >
            <v-text-field
              v-model="vola"
              v-money="money"
              :error-messages="errors.collect('vola')"
              data-vv-name="vola"
              label="VOLA"
              prefix="RM"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            lg="6"
            class="py-0"
          >
            <v-text-field
              v-model="leavePay"
              v-money="money"
              :error-messages="errors.collect('leavePay')"
              data-vv-name="leavePay"
              label="Leave Pay"
              prefix="RM"
            />
          </v-col>                  
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >          
            <v-text-field
              v-model="akind"
              v-money="money"
              :error-messages="errors.collect('akind')"
              data-vv-name="akind"
              label="Allowances in kind (food/clothing/lodging/servants provided)"
              prefix="RM"
            />
          </v-col>    
        </v-row>        

        <v-row>
          <v-col
            lg="6"
            class="py-0"
          >  
            <div 
              class="pt-3"
            >
              <span>Cash allowances including tax borne by the employer:</span>
              <v-row>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="aCashType"
                    v-validate="aCashAmt != 0 ? 'required' : ''"
                    :error-messages="errors.collect('aCashType')"
                    data-vv-name="aCashType"
                    data-vv-as="allowance type"                     
                    label="Allowance Type"
                  />  
                </v-col>      
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="aCashAmt"
                    v-money="money"
                    :error-messages="errors.collect('aCashAmt')"
                    data-vv-name="aCashAmt"
                    label="Amount"
                    prefix="RM"
                  />  
                </v-col>   
              </v-row>    
            </div>
          </v-col>  
          <v-col
            lg="6"
            class="py-0"
          >
            <div 
              class="pt-3"
            >
              <span>Other Payments:</span>
              <v-row>
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="specifyOther"
                    v-validate="otherAmt != 0 ? 'required' : ''"
                    :error-messages="errors.collect('specifyOther')"
                    data-vv-name="specifyOther"
                    data-vv-as="specify other"                     
                    label="Specify"
                  />  
                </v-col>      
                <v-col
                  cols="6"
                >
                  <v-text-field
                    v-model="otherAmt"
                    v-money="money"
                    :error-messages="errors.collect('otherAmt')"
                    data-vv-name="otherAmt"
                    label="Amount"
                    prefix="RM"
                  />   
                </v-col>   
              </v-row>    
            </div>          
          </v-col>
        </v-row>      
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="hrissecondary"
            class="white--text"
            @click="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    directives: { money: VMoney },    
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      detail: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },  
        salary: 0,
        commissionBonus: 0,
        vola: 0,
        bik: 0,
        leavePay: 0,
        akind: 0,
        aCashType: '',
        aCashAmt: 0,        
        specifyOther: '',
        otherAmt: 0,   
        employeeDetail: {},   
      }
    },
    watch: {
      detail: {
        immediate: true,
        handler (newVal) {
          if (!_.isEmpty(newVal)) {
            this.salary = newVal.salary
            this.commissionBonus = newVal.commissionBonus
            this.vola = newVal.vola
            this.bik = newVal.bik
            this.leavePay = newVal.leavePay
            this.akind = newVal.akind
            this.aCashType = newVal.aCashType
            this.aCashAmt = newVal.aCashAmt      
            this.specifyOther = newVal.specifyOther
            this.otherAmt = newVal.otherAmt                
          }
        },
      },
    },    
    methods: {
      save () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.employeeDetail = {
              id: this.detail.id,
              name: this.detail.name,
              salary: this.salary,
              bik: this.bik,
              vola: this.vola,
              commissionBonus: this.commissionBonus,
              akind: this.akind,
              leavePay: this.leavePay,
              aCashType: this.aCashType,
              aCashAmt: this.aCashAmt,
              specifyOther: this.specifyOther,
              otherAmt: this.otherAmt,          
            }

            this.$emit('updated-detail', this.employeeDetail)
            this.$snack({ message: 'Saved successfully for ' + this.detail.name })    
          })        
      },
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    height:65vh;
  }
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }
  ::v-deep .theme--light.v-text-field.v-input--is-disabled>.v-input__control>.v-input__slot:before {
    border-image: none;
  }
</style>
